import type * as Registration from '@/modules/authentication/view-model/models/registration-step.form-model';
import { coalesce } from '@/utils';

import { useRegistrationStore } from '../stores/registration.store';

export const useRegistrationActions = () => {
	const store = useRegistrationStore();

	const submitDateOfBirth = (data: Registration.DateOfBirthStep) => store.setPersonalInfo(data);
	const submitGender = (data: Registration.GenderStep) => store.setPersonalInfo(data);
	const submitPhoneNumber = (data: Registration.PhoneNumberStep) => store.setPersonalInfo(data);
	const submitResidence = (data: Registration.ResidenceStep) => store.setPersonalInfo(data);
	const submitEducation = (data: Registration.EducationStep) => store.setEducation(data);
	const submitGraduationStatus = (data: Registration.GraduationStatusStep) => store.setEducation(data);
	const submitEmploymentStatus = (data: Registration.EmploymentStatusStep) => store.setWorkHistory(data);
	const submitJobChangedCount = (data: Registration.JobChangedCountStep) => store.setWorkHistory(data);
	const submitCurrentCompany = (data: Registration.CurrentCompanyStep) => store.setWorkHistory(data);
	const submitJobIndustry = ({ industryId, subIndustryId }: Registration.JobIndustryStep) => store.setWorkHistory({ industryId: coalesce(subIndustryId, industryId) });
	const submitJobOccupation = ({ categoryId, specializationId, subCategoryId }: Registration.JobOccupationStep) => store.setWorkHistory({ occupationId: coalesce(specializationId, subCategoryId, categoryId) });
	const submitAnnualSalary = ({ currentAnnualSalary, expectedAnnualSalary }: Registration.AnnualSalaryStep) => store.setJobPreference({ currentAnnualSalary, expectedAnnualSalary });
	const submitDesiredJobOccupation = ({ preferredJobOccupations }: Registration.DesiredJobOccupationStep) => {
		store.setJobPreference({ preferredOccupationIds: preferredJobOccupations.map(({ categoryId, specializationId, subCategoryId }) => coalesce(specializationId, subCategoryId, categoryId)) });
	};
	const submitDesiredJobLocation = (data: Registration.DesiredJobLocationStep) => store.setJobPreference({ openToAnyLocations: data.openToAnyLocations, preferredLocationIds: data.preferredLocationIds });

	return {
		submitAnnualSalary,
		submitCurrentCompany,
		submitDateOfBirth,
		submitDesiredJobLocation,
		submitDesiredJobOccupation,
		submitEducation,
		submitEmploymentStatus,
		submitGender,
		submitGraduationStatus,
		submitJobChangedCount,
		submitJobIndustry,
		submitJobOccupation,
		submitPhoneNumber,
		submitResidence,
	};
};
